module.exports = {
          srcSet: __webpack_public_path__ + "efbc7a5f5d786a868dec04f258a88f3e-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "efbc7a5f5d786a868dec04f258a88f3e-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "efbc7a5f5d786a868dec04f258a88f3e-40.png",
          toString:function(){return __webpack_public_path__ + "efbc7a5f5d786a868dec04f258a88f3e-40.png"},
          
          width: 40,
          height: 40
        }